export enum Color {
    Red = '#FF0000',
    Yellow = '#FFFF00',
    Gold = '#FFD700',
    LightBlue = '#00CEEF',
    Blue = '#001FFF',
    Gray = '#818181',
    Orange = '#FF7800',
    Green = '#0DB000',
    Black = '#000000',
    DarkMagenta = '#8B008B',
    DarkOrange = '#FF8C00'
}



// WEBPACK FOOTER //
// ./src/app/helpers/color.enum.ts